import { useEffect } from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import { Button } from "@/components/ui/button";

export function LanguageToggle() {
  const { language, setLanguage } = useLanguage();

  useEffect(() => {
    console.log("Language updated in component:", language);
  }, [language]); // ✅ Logs when language changes

  return (
    <div className="flex gap-2">
      <Button
        variant={language === "no" ? "default" : "outline"}
        size="sm"
        onClick={() => setLanguage("no")}
        className="w-12"
      >
        NO
      </Button>
      <Button
        variant={language === "en" ? "default" : "outline"}
        size="sm"
        onClick={() => setLanguage("en")}
        className="w-12"
      >
        EN
      </Button>
    </div>
  );
}
